/*
 * File: GetPackages.ts
 * Author: Austin Robinson
 * Date Created: 8/4/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { privateApi } from 'api';

export type GetPackagesParams = unknown;

export type Package = {
  tenant_id: string;
  id: string;
  name: string;
  description: string | null;
  separate_charges: boolean;
  secure_seat_mode: 'at_time_of_enrollment' | 'when_deposit_paid' | 'when_full_cost_paid';
  advertise: boolean;
  deleted: boolean;
  location_count: number;
  course_count: number;
};

export type GetPackagesResult = Package[];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function getPackages(_params: GetPackagesParams | undefined): Promise<GetPackagesResult> {
  // make api call
  const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/packages`, {});

  // return the data object
  return result.data as GetPackagesResult;
}

const useGetPackages = createQuery<GetPackagesResult, GetPackagesParams, Error>({
  queryKey: ['packages'],
  fetcher: (variables) => getPackages(variables),
});

export { getPackages, useGetPackages };
